module.exports = __webpack_public_path__ + "img/footer-img-2.05702b7b.png";